import { wrapperStyle, containerStyle, titleStyle, hintStyle } from './AccessDeniedPage.tailwind';

const AccessDeniedPage = () => {
  return (
    <div className={wrapperStyle}>
      <div className={containerStyle}>
        <h2 className={titleStyle}>Access Denied</h2>
        <p className={hintStyle}>Ask for permission in Administrator*</p>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
